// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dd-spinner {
  width: 100%;
  z-index: 1080;
  display: table;
  text-align: center;
}
.dd-spinner .spinner-text {
  color: #c00;
}
.dd-spinner.small {
  height: 16px;
}
.dd-spinner.small.dark {
  background: url('red-16px.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.small.light {
  background: url('white-16px.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.small .spinner-text {
  display: table-cell;
  vertical-align: middle;
  padding-top: 60px;
}
.dd-spinner.medium {
  height: 80px;
}
.dd-spinner.medium.dark {
  background: url('red-small-spinner.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.medium.light {
  background: url('white-small-spinner.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.medium .spinner-text {
  display: table-cell;
  vertical-align: middle;
  padding-top: 100px;
}
.dd-spinner.large {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.dd-spinner.large.dark {
  background: url('red-medium-spinner-w-logo.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.large.light {
  background: url('white-medium-spinner-w-logo.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.large .spinner-text {
  display: table-cell;
  vertical-align: middle;
  padding-top: 165px;
}
.dd-spinner.x-large {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}
.dd-spinner.x-large.dark {
  background: url('red-large-spinner-w-logo.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.x-large.light {
  background: url('white-large-spinner-w-logo.gif') no-repeat center center rgba(255, 255, 255, 0.8);
}
.dd-spinner.x-large .spinner-text {
  display: table-cell;
  padding-top: 380px;
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/component/general/dd-spinner/dd-spinner.scss","webpack://./src/assets/styles/variable.scss"],"names":[],"mappings":"AAIA;EACE,WAAA;EACA,aANe;EAOf,cAAA;EACA,kBAAA;AAHF;AAKE;EACE,WCXU;ADQd;AAME;EASE,YAAA;AAZJ;AAII;EACE,gFAAA;AAFN;AAKI;EACE,kFAAA;AAHN;AAQI;EACE,mBAAA;EACA,sBAAA;EACA,iBAAA;AANN;AASE;EASE,YAAA;AAfJ;AAOI;EACE,yFAAA;AALN;AAQI;EACE,2FAAA;AANN;AAUI;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;AARN;AAWE;EASE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AAjBJ;AAMI;EACE,iGAAA;AAJN;AAOI;EACE,mGAAA;AALN;AAYI;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;AAVN;AAaE;EASE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;AAnBJ;AAQI;EACE,gGAAA;AANN;AASI;EACE,kGAAA;AAPN;AAcI;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;AAZN","sourcesContent":["$zindex-spinner: 1080;\n$faded-white: rgba(255, 255, 255, 0.8);\n@import '../../../../assets/styles/variable.scss';\n\n.dd-spinner {\n  width: 100%;\n  z-index: $zindex-spinner;\n  display: table;\n  text-align: center;\n\n  .spinner-text {\n    color: $brand-color;\n  }\n  \n  &.small {\n    &.dark {\n      background: url(\"../../../../assets/images/gifs/red-16px.gif\")\n        no-repeat center center $faded-white;\n    }\n    &.light {\n      background: url(\"../../../../assets/images/gifs/white-16px.gif\")\n        no-repeat center center $faded-white;\n    }\n    height: 16px;\n\n    .spinner-text {\n      display: table-cell;\n      vertical-align: middle;\n      padding-top: 60px;\n    }\n  }\n  &.medium {\n    &.dark {\n      background: url(\"../../../../assets/images/gifs/red-small-spinner.gif\")\n        no-repeat center center $faded-white;\n    }\n    &.light {\n      background: url(\"../../../../assets/images/gifs/white-small-spinner.gif\")\n        no-repeat center center $faded-white;\n    }\n    height: 80px;\n    .spinner-text {\n      display: table-cell;\n      vertical-align: middle;\n      padding-top: 100px;\n    }\n  }\n  &.large {\n    &.dark {\n      background: url(\"../../../../assets/images/gifs/red-medium-spinner-w-logo.gif\")\n        no-repeat center center $faded-white;\n    }\n    &.light {\n      background: url(\"../../../../assets/images/gifs/white-medium-spinner-w-logo.gif\")\n        no-repeat center center $faded-white;\n    }\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    .spinner-text {\n      display: table-cell;\n      vertical-align: middle;\n      padding-top: 165px;\n    }\n  }\n  &.x-large {\n    &.dark {\n      background: url(\"../../../../assets/images/gifs/red-large-spinner-w-logo.gif\")\n        no-repeat center center $faded-white;\n    }\n    &.light {\n      background: url(\"../../../../assets/images/gifs/white-large-spinner-w-logo.gif\")\n        no-repeat center center $faded-white;\n    }\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    .spinner-text {\n      display: table-cell;\n      padding-top: 380px;\n      font-size: 2rem;\n    }\n  }  \n}","$brand-color: #c00;\n$header-height: 60px;\n$menu-tab-height: 48px;\n$footer-height: 35px;\n$link-color: #3f51b5;\n$review-not-begun:#c00;\n$review-in-process:#1495f1;\n$review-completed:#1aa520;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
